module.exports = __webpack_public_path__ + "static/img/icon_hxpyw.0e45fef5.png";